import { render } from "./sendJob.vue?vue&type=template&id=6b204628&scoped=true"
import script from "./sendJob.vue?vue&type=script&lang=js"
export * from "./sendJob.vue?vue&type=script&lang=js"

import "./sendJob.vue?vue&type=style&index=0&id=6b204628&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b204628"]])

export default __exports__